import { RepositoryDocumentsPage } from "@/components/revenueos/RepositoryDocumentsPage";

export default function TechnicalProposals() {
  return (
    <RepositoryDocumentsPage
      category="technical_proposal"
      title="Technical Proposals"
      description="Technical proposal documents, shared across every partner and admin."
    />
  );
}
